import React, { useState, useContext, useEffect, forwardRef } from "react";

import { Grid, Card, Typography, Button, Divider } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import MaterialTable from "material-table";

import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";

import Spinner from "../layout/Spinner";

import MonitoringContext from "../../context/monitoring/MonitoringContext";

const MonitoringLatestOrder = () => {
  const monitoringContext = useContext(MonitoringContext);
  const { loading, monitorings } = monitoringContext;
  const [rows, setRows] = useState([]);

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  // Table column
  const column = [
    {
      field: "store_name",
      title: "Store Name",
      cellStyle: {
        width: 150,
        minWidth: 150,
        fontSize: 12,
      },
    },
    {
      field: "order_name",
      title: "Order ID",
      cellStyle: {
        width: 150,
        minWidth: 150,
        fontSize: 12,
      },
    },
    {
      field: "last_created_at",
      title: "Created At",
      cellStyle: {
        width: 150,
        minWidth: 150,
        fontSize: 12,
      },
    },
  ];

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    card: {
      height: 550,
    },
    header: {
      backgroundColor: theme.palette.primary.dark,
      padding: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      height: 50,
    },
    headerText: {
      color: theme.palette.primary.contrastText,
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
    body: {
      padding: theme.spacing(1),
      paddingRight: theme.spacing(0),
      width: "100%",
    },
    list: {
      position: "relative",
      overflow: "auto",
      maxHeight: 520,
      width: "100%",
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    if (monitorings && monitorings.length > 0) {
      setRows([]);
      for (let x in monitorings) {
        setRows((rows) => [
          ...rows,
          {
            store_name: monitorings[x].store_name,
            order_name: monitorings[x].order_name,
            last_created_at: monitorings[x].last_created_at.slice(0, 10),
          },
        ]);
      }
    }
  }, [monitorings]);

  return (
    <Card className={classes.card}>
      <Grid
        container
        direction="row"
        alignItems="center"
        className={classes.header}
      >
        <Grid item>
          <Typography variant="h6" className={classes.headerText}>
            Latest Orders - by Stores{" "}
          </Typography>{" "}
        </Grid>{" "}
      </Grid>{" "}
      {loading === false && monitorings ? (
        <Grid container direction="row" spacing={1} className={classes.body}>
          <Grid item xs={12}>
            <Grid container direction="row" className={classes.list}>
              <Grid item xs={12}>
                <MaterialTable
                  columns={column}
                  data={rows}
                  icons={tableIcons}
                  options={{
                    paging: false,
                    toolbar: false,
                    sorting: true,
                    showTitle: false,
                    padding: "dense",
                    draggable: false,
                    headerStyle: {
                      fontWeight: "bold",
                      fontSize: 12,
                      zIndex: 0,
                    },
                  }}
                />{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>
      ) : (
        <Grid
          container
          direction="row"
          style={{
            height: 300,
          }}
          alignItems="flex-end"
          justifyContent="center"
        >
          <Grid item>
            <Spinner />
          </Grid>{" "}
        </Grid>
      )}{" "}
    </Card>
  );
};

export default MonitoringLatestOrder;
